import React from 'react';

import App from 'grommet/components/App';

export default function({children}) {
  return (
    <App centered={false}>
      {children}
    </App>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Main.js